<!-- Sidebar Header starts -->
<div class="sidebar-header">
  <div class="logo clearfix" style="background-color: white;">
    <a [routerLink]="['/']" class="logo-text float-left">
      <div class="logo-img">
        <img src="assets/img/logo.png" />
      </div>
      <!-- <span class="text align-middle">DVR Suite</span> -->
    </a>
    <small class="float-right text-muted"><strong>{{softwareVersion}}</strong></small>
    <!-- <a class="nav-toggle d-none d-sm-none d-md-none d-lg-block" id="sidebarToggle" href="javascript:;">
    <i class="ft-toggle-right toggle-icon" data-toggle="expanded"></i>
  </a>
  <a class="nav-close d-block d-md-block d-lg-none d-xl-none" id="sidebarClose" href="javascript:;">
    <i class="ft-x"></i>
  </a> -->
</div>
</div>
<!-- Sidebar Header Ends -->

<!-- Sidebar Content starts -->
<div class="sidebar-content">
  <div class="nav-container">
    <ul class="navigation">
      <!-- First level menu -->
      @for (menuItem of menuItems; track menuItem) {
        <li *appCheckRole="menuItem.roles" [ngClass]="[menuItem.class]"
          [routerLinkActive]="menuItem.submenu.length != 0 ? '' : 'active'">
          @if (!menuItem.isExternalLink) {
            <a [routerLink]="menuItem.class === '' ? [menuItem.path] : null"
              >
              <i [ngClass]="[menuItem.icon]"></i>
              <span class="menu-title">{{menuItem.title}}</span>
              @if (menuItem.badge != '' ) {
                <span [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
              }
            </a>
          } @else {
            <a [href]="[menuItem.path]" target="_blank">
              <i [ngClass]="[menuItem.icon]"></i>
              <span class="menu-title">{{menuItem.title}}</span>
              @if (menuItem.badge != '' ) {
                <span [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
              }
            </a>
          }
          <!-- Second level menu -->
          @if (menuItem.submenu.length > 0) {
            <ul class="menu-content">
              @for (menuSubItem of menuItem.submenu; track menuSubItem) {
                <li
                  [routerLinkActive]="menuSubItem.submenu.length > 0 ? '' : 'active'" [ngClass]="[menuSubItem.class]">
                  @if (!menuSubItem.isExternalLink) {
                    <a [routerLink]="menuSubItem.submenu.length > 0 ? null : [menuSubItem.path]"
                      >
                      <i [ngClass]="[menuSubItem.icon]"></i>
                      <span class="menu-title">{{menuSubItem.title}}</span>
                      @if (menuSubItem.badge != '' ) {
                        <span [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                      }
                    </a>
                  } @else {
                    <a [href]="[menuSubItem.path]">
                      <i [ngClass]="[menuSubItem.icon]"></i>
                      <span class="menu-title">{{menuSubItem.title}}</span>
                      @if (menuSubItem.badge != '' ) {
                        <span
                        [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                      }
                    </a>
                  }
                  <!-- Third level menu -->
                  @if (menuSubItem.submenu.length > 0) {
                    <ul class="menu-content">
                      @for (menuSubsubItem of menuSubItem.submenu; track menuSubsubItem) {
                        <li routerLinkActive="active"
                          [routerLinkActiveOptions]="{exact: true}" [ngClass]="[menuSubsubItem.class]">
                          @if (!menuSubsubItem.isExternalLink) {
                            <a [routerLink]="[menuSubsubItem.path]"
                              >
                              <i [ngClass]="[menuSubsubItem.icon]"></i>
                              <span class="menu-title">{{menuSubsubItem.title}}</span>
                              @if (menuSubsubItem.badge != '' ) {
                                <span
                                [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                              }
                            </a>
                          } @else {
                            <a [href]="[menuSubsubItem.path]">
                              <i [ngClass]="[menuSubsubItem.icon]"></i>
                              <span class="menu-title">{{menuSubsubItem.title}}</span>
                              @if (menuSubsubItem.badge != '' ) {
                                <span
                                [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                              }
                            </a>
                          }
                        </li>
                      }
                    </ul>
                  }
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </div>
</div>
<!-- {{menuItems | json}} -->
